import type { CreatedEvent } from "../../../redux/features/event/event.types";

export const MIN_ATTENDANCE_SIGNAL_COUNT = 50;

export const getEventAttendance = (event?: CreatedEvent) => {
  const attendanceAlias =
    typeof event?.attendance === "number" ? undefined : event?.attendance;
  const countValue =
    event?.attendanceSummary?.totalPaidTickets ??
    attendanceAlias?.totalPaidTickets ??
    event?.attendeeCount ??
    (typeof event?.attendance === "number" ? event.attendance : 0);
  const totalPaidTickets =
    typeof countValue === "number" && Number.isFinite(countValue)
      ? countValue
      : 0;
  const attendeeNames =
    event?.attendanceSummary?.attendeeNames ??
    attendanceAlias?.attendeeNames ??
    event?.attendeeNames ??
    event?.attendanceSummary?.attendees?.map((attendee) => attendee.name) ??
    attendanceAlias?.attendees?.map((attendee) => attendee.name) ??
    [];

  return {
    totalPaidTickets,
    attendeeNames: attendeeNames.filter(Boolean).slice(0, 5),
  };
};

export const shouldShowAttendanceSignal = (totalPaidTickets: number) => {
  return totalPaidTickets >= MIN_ATTENDANCE_SIGNAL_COUNT;
};
